/*
 * max width of the body container in desktop view
 */
export const BODY_MAX_WIDTH = '35.5em';
